import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { Typography } from 'shared/mui/Typography';

type Props = {
  onClick: VoidFunction;
};

export const OrderConversionListGatewaySettingsAlert: React.FC<Props> = ({ onClick }) => {
  const translate = useTypedTranslate();

  return (
    <Alert severity="warning">
      <Box
        sx={{
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          marginLeft: '8px',
        }}
      >
        <Typography variant="body2">
          {translate('app.orderConversion.maxAllowedDeviationFromAvg14DaysDescription')}
        </Typography>
        <Button
          label={translate('app.orderConversion.setupGuide')}
          onClick={onClick}
          sx={{ marginLeft: '-8px', color: 'rgb(102, 60, 0)' }}
        />
      </Box>
    </Alert>
  );
};
